import { render, staticRenderFns } from "./OccurCreate.vue?vue&type=template&id=472e3a8a&"
import script from "./OccurCreate.vue?vue&type=script&lang=ts&"
export * from "./OccurCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports